import './course-review.scss';
import Avatar from '../../UI/Avatar'
import { BsStarFill } from 'react-icons/bs'
import {CourseReview as CourseReviewType} from "../../../typings/course";
const CourseReview = (props: CourseReviewType) => {
  const {avatar, name, rate, description} = props
  return (
    <>
      <div className="flex flex-col review-item mb-4 gap-2">
        <div className="flex justify-between items-center review-item-header">
          <div className="flex items-center review-item-info mr-3">
            <Avatar image={avatar || 'https://placehold.co/60'} customClass='me-3 border rounded-circle' variant='circle' size='2.5rem' />
            <span className="font-bold">{name}</span>
          </div>
          <div className="review-item-action justify-end">
            <div className="review-item-rating-label">
              <BsStarFill className="mr-2 fill-primary"/>
              <span className="font-bold">{rate}</span>
            </div>
          </div>
        </div>
        <div className="review-item-desc w-full">
          {description}
        </div>
        <div className="flex items-center review-item-footer">
          <span className="fs-7">3 menit yang lalu</span>
        </div>
      </div>
    </>
  )
}
export default CourseReview;
